import { HeaderSelectMenuItemsEnum } from 'features/header/enums/header-select-menu-items.enum';

export const SELECT_MENU_ITEM_ROUTES: Record<string, string> = {
  [HeaderSelectMenuItemsEnum.SECURITY]: '/security',
};
